import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../chunks/tslib.es6.js";
import r from "../Color.js";
import { JSONMap as s } from "../core/jsonMap.js";
import { clone as e } from "../core/lang.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as i } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as l } from "../core/accessorSupport/decorators/subclass.js";
import a from "./FillSymbol.js";
import n from "./SimpleLineSymbol.js";

var _p;

var c = new s({
  esriSFSSolid: "solid",
  esriSFSNull: "none",
  esriSFSHorizontal: "horizontal",
  esriSFSVertical: "vertical",
  esriSFSForwardDiagonal: "forward-diagonal",
  esriSFSBackwardDiagonal: "backward-diagonal",
  esriSFSCross: "cross",
  esriSFSDiagonalCross: "diagonal-cross"
});

var m = _p = /*#__PURE__*/function (_a) {
  _inherits(p, _a);

  var _super = _createSuper(p);

  function p() {
    var _this;

    _classCallCheck(this, p);

    for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
      o[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(o)), _this.color = new r([0, 0, 0, .25]), _this.outline = new n(), _this.type = "simple-fill", _this.style = "solid";
    return _this;
  }

  _createClass(p, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(o, r, s) {
      if (o && "string" != typeof o) return o;
      var e = {};
      return o && (e.style = o), r && (e.outline = r), s && (e.color = s), e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _p({
        color: e(this.color),
        outline: this.outline && this.outline.clone(),
        style: this.style
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      return "".concat(_get(_getPrototypeOf(p.prototype), "hash", this).call(this)).concat(this.style, ".").concat(this.color && this.color.hash());
    }
  }]);

  return p;
}(a);

o([t()], m.prototype, "color", void 0), o([t()], m.prototype, "outline", void 0), o([i({
  esriSFS: "simple-fill"
}, {
  readOnly: !0
})], m.prototype, "type", void 0), o([t({
  type: c.apiValues,
  json: {
    read: c.read,
    write: c.write
  }
})], m.prototype, "style", void 0), m = _p = o([l("esri.symbols.SimpleFillSymbol")], m);
var S = m;
export { S as default };